import styles from './DisplayedByName.module.scss';

export const DisplayedByName = ({ setSortField, searchOptions }) => {
    return (
        <div className={styles['search-sort']}>
            <select onChange={(e) => setSortField(e.target.value)}>
                {searchOptions?.map((option, index) => (
                    <option key={index} value={option.value}>
                        Сортувати {option.name}
                    </option>
                ))}
            </select>
        </div>
    );
};
